/**
 * Custom Meta Pixel tracking helper for OkiForm Theme
 * Handles ViewContent, Search, and InitiateCheckout events.
 */
(function() {
  function initMetaPixelTracking() {
    if (typeof window.fbq !== 'function') return;

    // 1. ViewContent Tracking
    if (window.themeProductData) {
      try {
        window.fbq('track', 'ViewContent', {
          value: parseFloat(window.themeProductData.value) || 0,
          currency: window.themeProductData.currency || 'TRY',
          content_ids: [window.themeProductData.variantId.toString()],
          content_type: 'product',
          content_name: window.themeProductData.title
        });
      } catch (e) {
        console.error('Error tracking ViewContent:', e);
      }
    }

    // 2. Search Tracking
    if (window.themeSearchTerms) {
      try {
        window.fbq('track', 'Search', {
          search_string: window.themeSearchTerms
        });
      } catch (e) {
        console.error('Error tracking Search:', e);
      }
    }

    // 3. InitiateCheckout Tracking
    document.addEventListener('click', function(event) {
      const checkoutButton = event.target.closest('[name="checkout"]');
      if (checkoutButton) {
        try {
          fetch('/cart.js')
            .then(res => res.json())
            .then(cart => {
              const itemValue = cart.total_price / 100;
              const itemCurrency = cart.currency || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'TRY';
              const contentIds = cart.items.map(item => item.variant_id.toString());
              
              window.fbq('track', 'InitiateCheckout', {
                value: itemValue,
                currency: itemCurrency,
                content_ids: contentIds,
                content_type: 'product',
                num_items: cart.item_count
              });
            })
            .catch(err => console.error('Error fetching cart for InitiateCheckout:', err));
        } catch (e) {
          console.error('Error tracking InitiateCheckout:', e);
        }
      }
    });
  }

  // Initialize tracking
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMetaPixelTracking);
  } else {
    initMetaPixelTracking();
  }
})();
